import { useSelector } from 'react-redux';

import enabledAssetsSelector from '@/ui/flux/assets/selectors/enabled-assets';
import selectors from '@/ui/flux/selectors';
import { type ActivityEntry } from '@/ui/flux/tx-log/selectors/create-filtered-activity';
import useActivity from '@/ui/hooks/use-activity';

interface OrderSet {
  size: number;
}

function usePendingBuyActivityCount(): number {
  const pendingBuyOrders = useSelector(
    selectors.fiatRamp.inProgressOrders,
  ) as OrderSet;

  return pendingBuyOrders.size;
}

function usePendingOtherActivityCount(): number {
  const assets = useSelector(enabledAssetsSelector);

  const activity = useActivity({
    assetNames: Object.keys(assets),
    type: 'all',
  }) as ActivityEntry[];

  const pendingActivity = activity.filter(
    (activity) =>
      activity.type !== 'label' &&
      activity.type !== 'fiat' && // `fiat` might not always be included, but if it is, we want to exclude it.
      activity.pending,
  );

  return pendingActivity.length;
}

function usePendingCount(): number {
  const pendingBuyActivityCount = usePendingBuyActivityCount();
  const pendingOtherActivityCount = usePendingOtherActivityCount();
  return pendingBuyActivityCount + pendingOtherActivityCount;
}

export default usePendingCount;
